import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import withRouter from '../Components/Common/withRouter';

//import actions
import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changeSidebarVisibility
} from "../store/layout/action";

//redux
import { useSelector, useDispatch } from "react-redux";
import { changeThemeColor } from 'slices/thunks';
import { ApplicationState } from 'store';
import { setFavicon, themeSelector } from 'Components/Common/ThemeSettings/themeutitlity';
import { documentOpenGetRequest } from 'store/documents/action';



const NonAuthLayout = ({ children }: any) => {
    const dispatch :any= useDispatch();
    const layout = useSelector((state: ApplicationState) => state.layout);
    const {
        layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        preloader,
        sidebarVisibilitytype,
        themePrimary,
        themeSecondary,
        dark_logo,
        light_logo,
        dark_logo_sm,
        light_logo_sm
    } = layout;
    /*
    layout settings
    */
    useEffect(() => {
        if (
            layoutType ||
            leftSidebarType ||
            layoutModeType ||
            layoutWidthType ||
            layoutPositionType ||
            topbarThemeType ||
            leftsidbarSizeType ||
            leftSidebarViewType ||
            leftSidebarImageType ||
            sidebarVisibilitytype ||
            themePrimary
        ) {
            window.dispatchEvent(new Event('resize'));
            dispatch(changeLeftsidebarViewType(leftSidebarViewType));
            dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
            dispatch(changeSidebarTheme(leftSidebarType));
            dispatch(changeLayoutMode(layoutModeType));
            dispatch(changeLayoutWidth(layoutWidthType));
            dispatch(changeLayoutPosition(layoutPositionType));
            dispatch(changeTopbarTheme(topbarThemeType));
            dispatch(changeLayout(layoutType));
            dispatch(changeSidebarImageType(leftSidebarImageType));
            dispatch(changeSidebarVisibility(sidebarVisibilitytype));
            dispatch(changeThemeColor(themePrimary));
        }
    }, [layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype,
        themePrimary,
        dark_logo,
        light_logo,
        dark_logo_sm,
        light_logo_sm,
        themeSecondary,
        dispatch]);

    const [headerClass, setHeaderClass] = useState<any>("");
    // class add remove in header
    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
    });
    function scrollNavigation() {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setHeaderClass("topbar-shadow");
        } else {
            setHeaderClass("");
        }
    }

    useEffect(() => {
        themeSelector(dispatch, layoutModeType)
    }, []);
    useEffect(() => {
        if(dark_logo_sm) {
            dispatch(
                documentOpenGetRequest(
                    dark_logo_sm,
                    "students",
                    (error: any) => {
                        console.error("Error fetching avatar:", error);
                    },
                    (result: { url: string }) => {
                        if (result && result.url) {
                            setFavicon(result.url)
                        }
                    }
                )
            );
        }
        else {
            const faviconUrl = `${process.env.PUBLIC_URL}/favicon.ico`;
            const link: HTMLLinkElement =
                document.querySelector("link[rel*='icon']") || document.createElement("link");
            link.type = "image/x-icon";
            link.rel = "icon";
            link.href = faviconUrl;
            document.head.appendChild(link);
        }
    }, [dark_logo_sm])

    return (
        <React.Fragment>
            <div id="layout-wrapper">
                <div>
                    {children}
                </div>
            </div>
        </React.Fragment>

    );
};

NonAuthLayout.propTypes = {
    children: PropTypes.object,
};

export default withRouter(NonAuthLayout);
